/**
 * Canonical gold bars from brand/source/soundlayer-bars.svg,
 * downscaled in web/public/brand. The service identity is distinct from
 * individual catalog artwork; verify the actual Sonos presentation separately.
 * Proportions are square; never stretch it.
 */
export function Logo({ size = 28, className = "" }: { size?: number; className?: string }) {
  const src = size > 96 ? "/brand/soundlayer-logo-512.png?v=gold-bars-20260916" : size > 48 ? "/brand/soundlayer-logo-192.png?v=gold-bars-20260916" : "/brand/soundlayer-logo-96.png?v=gold-bars-20260916";
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      className={`logo ${className}`.trim()}
      style={{ width: size, height: size }}
      draggable={false}
    />
  );
}
